//US ENGLISH

const spanishTranslations = {};

export default spanishTranslations;
